<div provide-parent-form>
    <div ngModelGroup="doubledeckerpizza">
        <div class="w-100" *ngIf="reason === 'city'">
            <mat-form-field class="w-100">
                <mat-label for="City">
                    {{ 'copy.label.FEATURES.ADDRESS.citylabel' | copy | async }}</mat-label>
                <input matInput name="{{guest.$mtcUUID}}City" [disabled]="disabled" aria-label="City" type="text" maxlength="25"
                    style="text-transform: capitalize;" pattern="^[A-Za-z\s\-\_'.]*$" [(ngModel)]="guestCity.Value" (ngModelChange)="setGuestCity($event)"
                    #city="ngModel" required />
                <mat-error><app-validation [object]="city" pattern="alpha"
                        isRequired="true"></app-validation></mat-error>
            </mat-form-field>
        </div>

        <div class="w-100" *ngIf="reason === 'state'">
            <mat-form-field class="w-100 required">
                <mat-label for="state">
                    {{ 'copy.label.FEATURES.ADDRESS.USstatelabel' | copy | async }}</mat-label>
                <mat-select name="{{guest.$mtcUUID}}state" [disabled]="disabled" [(ngModel)]="guestState.Value" #stateProvince="ngModel" required
                    matNativeControl>
                    <mat-option *ngFor="let obj of stateList" [value]="obj.code">
                        {{obj.name}}</mat-option>
                </mat-select>
                <mat-error><app-validation [object]="stateProvince" isRequired="true"></app-validation></mat-error>
            </mat-form-field>
        </div>


        <div class="w-100 required" *ngIf="reason === 'lang'">
            <label>{{ 'copy.label.FEATURES.PERSONAL.languageInterp' | copy | async }}</label>
            <div>
                <mat-radio-group [disabled]="disabled" [(ngModel)]="langinterp.Value" name="{{guest.$mtcUUID}}languageInterp" #languageInterp="ngModel"
                    required>
                    <mat-radio-button value="Yes">Yes</mat-radio-button>
                    <mat-radio-button value="No">No</mat-radio-button>
                    <div class="w-100">
                        <small class="text-danger"><app-validation [object]="languageInterp"
                            isRequired="true"></app-validation></small>
                    </div>
                </mat-radio-group>
            </div>
        </div>

        <div class="w-100">
            <div class="d-flex flex-column justify-content-start" *ngIf="reason === 'neuro'">
                <!-- <div class="like-label-color" [innerHTML]="'copy.label.FEATURES.PERSONAL.neurodiversityText' | copy | async"></div> -->
                <mat-form-field class="w-100">
                    
                    <mat-label for="nueroConsiderations" aria-labelledby="nueroConsiderations" style="text-wrap:wrap;">
                        {{ 'copy.label.ATTENDEE.neurodiversity' | copy | async }}</mat-label>
                      <textarea [disabled]="disabled" matInput class="w-100" name="{{guest.$mtcUUID}}nueroConsiderations" id="nueroConsiderations"
                        aria-label="nueroConsiderations" [(ngModel)]="nuerdiv.Value"
                        maxlength="225"  pattern="^[\w\s!@\-\_:',.\/?]*" #nueroConsiderations="ngModel"></textarea>
                      <mat-error><app-validation [object]="nueroConsiderations"  pattern="alphanum"></app-validation></mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="w-100" *ngIf="reason === 'allergies'">
            {{ 'copy.label.FEATURES.DIETARY.foodallergies' | copy | async }}
            <i class="fas fa-asterisk required" style="font-size: .4rem; vertical-align: super"></i>
            <div *ngFor="let allergy of foodAllergiesList">
              <div class="agreeCheckbox my-2">
                <div class="checkboxFlexContainer">
                  <mat-checkbox  [disabled]="disabled" name="{{guest.$mtcUUID}}allergies{{allergy.code}}"
                    [ngModel]="includes(guest.$mtcAllergens,allergy.code)"
                    (change)="allergyUpdate(allergy)"
                    aria-labelledby="{{ allergy.code }}_label" 
                    #allergies{{allergy.code}}
                    [required]="guest.$mtcAllergens.length === 0"></mat-checkbox>
                  <label id="{{ allergy.code }}_label">{{ allergy.name }}</label>
                </div>
              </div>
            </div>
            <div class="w-100" *ngIf="guest.$mtcAllergens.length === 0 ">
              <small class="text-danger">At least one food allergy must be selected.</small>
            </div> 
          </div>




    </div>
</div>